/**
 * First-touch attribution.
 *
 * The very first time a browser lands on the site we capture the referrer
 * and UTM params and pin them in localStorage. Every subsequent conversion
 * event (checkout_start, signup_start, etc.) is enriched with these values
 * so we can answer "which channel actually turned into a paying user" —
 * not just "which channel drove traffic".
 */

const FIRST_TOUCH_KEY = 'fff_first_touch_v1';

const safeGet = () => {
  try {
    const raw = localStorage.getItem(FIRST_TOUCH_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch { return null; }
};

const safeSet = (obj) => {
  try { localStorage.setItem(FIRST_TOUCH_KEY, JSON.stringify(obj)); } catch { /* private mode */ }
};

export const captureFirstTouch = () => {
  if (safeGet()) return safeGet(); // already recorded — first-touch never changes
  const qs = (() => {
    try { return new URLSearchParams(window.location.search); } catch { return new URLSearchParams(); }
  })();
  const payload = {
    referrer: (document.referrer || '').slice(0, 500),
    landing_path: window.location.pathname,
    utm_source: qs.get('utm_source') || '',
    utm_medium: qs.get('utm_medium') || '',
    utm_campaign: qs.get('utm_campaign') || '',
    ref_code: qs.get('ref') || '',
    captured_at: new Date().toISOString(),
  };
  safeSet(payload);
  return payload;
};

export const getFirstTouch = () => safeGet() || {};
